import { applyStyle, escapeHtml } from '../css';
import { icons } from '../icons';
import { appState } from '../../state';
const VERSION_FALLBACK = 'v0.2.40';
export function defaultNavGroups() {
    return [
        {
            label: 'Ana',
            items: [
                { id: 'connect', label: 'Bağlan', iconHtml: icons.arrowRight() },
                { id: 'panel', label: 'Panel', iconHtml: icons.grid() },
                { id: 'session', label: 'Uzak Oturum', iconHtml: icons.monitor(), disabled: true },
            ],
        },
        {
            label: 'Ağ',
            items: [
                { id: 'contacts', label: 'Kişiler', iconHtml: icons.users() },
                { id: 'files', label: 'Dosya Transferi', iconHtml: icons.upload() },
                { id: 'meeting', label: 'Toplantı', iconHtml: icons.video() },
                { id: 'chat', label: 'Sohbet', iconHtml: icons.message(), badge: '3' },
            ],
        },
        {
            label: 'Sistem',
            items: [
                { id: 'webauthn', label: 'Anahtarlar', iconHtml: icons.key() },
                { id: 'admin', label: 'Admin', iconHtml: icons.shield(), adminOnly: true },
                { id: 'settings', label: 'Ayarlar', iconHtml: icons.settings() },
                { id: 'about', label: 'Hakkında', iconHtml: icons.info() },
            ],
        },
    ];
}
export function createSidebar(opts) {
    const aside = document.createElement('aside');
    applyStyle(aside, {
        width: 'var(--sidebar-w)',
        minWidth: 'var(--sidebar-w)',
        height: '100vh',
        background: 'var(--bg-elev-1)',
        borderRight: '1px solid var(--border-subtle)',
        display: 'flex',
        flexDirection: 'column',
        position: 'sticky',
        top: '0',
        overflowY: 'auto',
    });
    // Marka — logo + isim + sürüm
    const brand = document.createElement('div');
    applyStyle(brand, {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--sp-3)',
        padding: 'var(--sp-5) var(--sp-5) var(--sp-5)',
    });
    brand.innerHTML = `
    ${icons.logo()}
    <div style="display:flex;flex-direction:column;line-height:1.1">
      <span style="font-family:var(--font-display);font-style:italic;font-size:20px;font-weight:500;color:var(--text-primary)">PhotonRemote</span>
      <span style="font-size:var(--fs-tiny);letter-spacing:0.18em;color:var(--text-tertiary);margin-top:2px">REMOTE · ${escapeHtml(opts.version ?? VERSION_FALLBACK)}</span>
    </div>
  `;
    aside.append(brand);
    const navWrap = document.createElement('nav');
    applyStyle(navWrap, {
        flex: '1',
        padding: 'var(--sp-2) var(--sp-3)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--sp-4)',
    });
    for (const group of opts.groups) {
        const visibleItems = group.items.filter(it => !it.adminOnly || appState.isAdmin);
        if (visibleItems.length === 0)
            continue;
        const groupWrap = document.createElement('div');
        applyStyle(groupWrap, { display: 'flex', flexDirection: 'column', gap: 'var(--sp-1)' });
        const label = document.createElement('div');
        label.textContent = group.label.toUpperCase();
        applyStyle(label, {
            fontSize: 'var(--fs-tiny)',
            letterSpacing: '0.16em',
            color: 'var(--text-tertiary)',
            padding: 'var(--sp-2) var(--sp-3) var(--sp-1)',
            fontWeight: '500',
        });
        groupWrap.append(label);
        for (const item of visibleItems) {
            groupWrap.append(navItemEl(item, opts));
        }
        navWrap.append(groupWrap);
    }
    aside.append(navWrap);
    // Alt: kullanıcı chip + logout
    if (opts.userEmail) {
        const footer = document.createElement('div');
        applyStyle(footer, {
            borderTop: '1px solid var(--border-subtle)',
            padding: 'var(--sp-4) var(--sp-5)',
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--sp-3)',
        });
        const initials = (opts.userEmail.split('@')[0].slice(0, 2) || 'PR').toUpperCase();
        const avatar = document.createElement('div');
        avatar.textContent = initials;
        applyStyle(avatar, {
            width: '32px',
            height: '32px',
            borderRadius: 'var(--radius-pill)',
            background: 'var(--accent-soft)',
            color: 'var(--accent)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '700',
            fontSize: 'var(--fs-caption)',
            flexShrink: '0',
        });
        footer.append(avatar);
        const info = document.createElement('div');
        applyStyle(info, { display: 'flex', flexDirection: 'column', minWidth: '0', flex: '1' });
        const name = document.createElement('span');
        name.textContent = opts.userEmail.split('@')[0];
        applyStyle(name, {
            fontSize: 'var(--fs-body)',
            fontWeight: '600',
            color: 'var(--text-primary)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        });
        const status = document.createElement('span');
        status.innerHTML = '<span style="display:inline-block;width:6px;height:6px;border-radius:50%;background:var(--status-online);margin-right:6px;box-shadow:0 0 0 3px rgba(34,197,94,0.25)"></span>çevrimiçi';
        applyStyle(status, {
            fontSize: 'var(--fs-tiny)',
            color: 'var(--text-tertiary)',
        });
        info.append(name, status);
        footer.append(info);
        if (opts.onLogout) {
            const lo = document.createElement('button');
            lo.type = 'button';
            lo.innerHTML = icons.logout();
            lo.title = 'Çıkış';
            applyStyle(lo, {
                background: 'transparent',
                border: '1px solid transparent',
                borderRadius: 'var(--radius-sm)',
                color: 'var(--text-tertiary)',
                cursor: 'pointer',
                padding: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background var(--motion-fast), color var(--motion-fast)',
            });
            lo.addEventListener('mouseenter', () => {
                lo.style.background = 'var(--bg-elev-3)';
                lo.style.color = 'var(--status-error)';
            });
            lo.addEventListener('mouseleave', () => {
                lo.style.background = 'transparent';
                lo.style.color = 'var(--text-tertiary)';
            });
            lo.addEventListener('click', () => opts.onLogout?.());
            footer.append(lo);
        }
        aside.append(footer);
    }
    return aside;
}
function navItemEl(item, opts) {
    const isActive = item.id === opts.activeRoute;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.disabled = !!item.disabled;
    btn.dataset.route = item.id;
    applyStyle(btn, {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--sp-3)',
        width: '100%',
        padding: '10px 12px',
        fontSize: 'var(--fs-body)',
        fontWeight: isActive ? '600' : '500',
        fontFamily: 'inherit',
        textAlign: 'left',
        background: isActive ? 'var(--accent-soft)' : 'transparent',
        color: isActive ? 'var(--accent)' : 'var(--text-secondary)',
        border: '1px solid ' + (isActive ? 'var(--accent)' : 'transparent'),
        borderRadius: 'var(--radius-sm)',
        cursor: item.disabled ? 'not-allowed' : 'pointer',
        opacity: item.disabled ? '0.45' : '1',
        transition: 'background var(--motion-fast), color var(--motion-fast)',
    });
    const iconWrap = document.createElement('span');
    iconWrap.innerHTML = item.iconHtml;
    applyStyle(iconWrap, { display: 'flex', alignItems: 'center' });
    btn.append(iconWrap);
    const labelEl = document.createElement('span');
    labelEl.textContent = item.label;
    applyStyle(labelEl, { flex: '1' });
    btn.append(labelEl);
    if (item.badge) {
        const b = document.createElement('span');
        b.textContent = item.badge;
        applyStyle(b, {
            fontSize: 'var(--fs-tiny)',
            fontWeight: '700',
            padding: '2px 8px',
            background: isActive ? 'var(--accent)' : 'var(--bg-elev-3)',
            color: isActive ? 'var(--on-accent)' : 'var(--text-secondary)',
            borderRadius: 'var(--radius-pill)',
        });
        btn.append(b);
    }
    if (!item.disabled) {
        btn.addEventListener('click', () => opts.onNavigate(item.id));
        btn.addEventListener('mouseenter', () => {
            if (!isActive) {
                btn.style.background = 'var(--bg-elev-2)';
                btn.style.color = 'var(--text-primary)';
            }
        });
        btn.addEventListener('mouseleave', () => {
            if (!isActive) {
                btn.style.background = 'transparent';
                btn.style.color = 'var(--text-secondary)';
            }
        });
    }
    return btn;
}
